<template>
  <v-card flat color="transparent" @dragenter.prevent @dragover.prevent>
    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="12">
          <div @drop="onDrop" @drop.prevent>
            <v-card
              flat
              tile
              color="#eaeaea"
              style="border: 2px dashed #aeaeae"
            >
              <v-card-title class="subtitle-2"
                >Drag Images or files here</v-card-title
              >
              <v-card-text>
                <v-row><v-col class="py-0">or</v-col></v-row>

                <v-row>
                  <v-col>
                    <v-file-input
                      v-model="filesValue"
                      multiple
                      ref="fileInput"
                      style="display:none;"
                    ></v-file-input>

                    <v-btn
                      small
                      depressed
                      tile
                      color="secondary"
                      @click="browseFiles"
                      >Browse</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="files && files.length">
        <v-col cols="12" v-for="(file, index) in files" :key="index">
          {{ file.name }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FileUploadInput',
  props: {
    files: {
      default: []
    }
  },
  computed: {
    filesValue: {
      get() {
        return this.files
      },
      set(newVal) {
        this.$emit('update:files', newVal)
      }
    }
  },
  methods: {
    onDrop(e) {
      this.files = e.dataTransfer.files
    },
    browseFiles() {
      this.$refs.fileInput.$refs.input.click()
    }
  }
}
</script>
